export const CONFIGURATOR_LOAD = "CONFIGURATOR_LOAD";
export const CONFIGURATOR_SET = "CONFIGURATOR_SET";
export const DELIVERYCONFIG_SET = "DELIVERYCONFIG_SET";
export const CONFIGURATOR_CLEAR = "CONFIGURATOR_CLEAR";
export const CONFIGURATOR_CLOSE = "CONFIGURATOR_CLOSE";
export const CONFIGURATOR_SET_TEMP = "CONFIGURATOR_SET_TEMP";
export const CONFIGURATOR_SET_SAVEBUTTONDISABLE = "CONFIGURATOR_SET_SAVEBUTTONDISABLE";
export const ADD_RECOMMENDED_PRODUCT = 'ADD_RECOMMENDED_PRODUCT';
export const REMOVE_RECOMMENDED_PRODUCT = 'REMOVE_RECOMMENDED_PRODUCT';
export const UPDATE_RECOMMENDED_PRODUCT_QUANTITY = 'UPDATE_RECOMMENDED_PRODUCT_QUANTITY';

import {showCustomizedMessage,hideCustomizedMessage,updateCustomizedMessage } from "../Actions/CustomizedMessage.action";
import {setDoOptimization} from "../Actions/Checkout.action";
import { translate } from "../Services/translation";
import { receive, loadError } from "./Cart.action";
import { post, get } from "../Services/http";
import { catchError } from "./Error.action";
import {receiveSelectedCart,clearSelectedCart} from '../Actions/SavedCart.action'

export const save = ({ articleNumber, orderRow = null, quantity, isUpdateMode,isSavedCart,cartId,selectedRecommendedProducts }) => {
  return (dispatch, getState) => {
    if (!quantity || isNaN(quantity)) {
      return;
    }
    dispatch(setDoOptimization(false));
    dispatch(updateCustomizedMessage(translate("cartmessage.cartcalculating"), "","#f7f7f7","#000"));
    
    let state = getState();
    let selectedUnit = state.productConfigurator.selectedUnit;
    let selections = state.productConfigurator.selections;
    let deliveryDetails = state.productConfigurator.deliveryDetails;
    const addedProduct = isUpdateMode ? undefined : articleNumber;

    dispatch(receive({isComplete: false}));
    if (isSavedCart) {
    dispatch(clearSelectedCart());
      return post("/api/configurator/savedcart/update", {
        articleNumber,
        quantity: quantity,
        orderRow,
        data: selections,
        selectedUnit,
        deliveryDetails: deliveryDetails,
        cartId: cartId,
      })
        .then((response) => response.json())
        .then((data) => {
          dispatch(receiveSelectedCart(data,cartId)),
          dispatch(hideCustomizedMessage());
        })
        .catch((ex) =>
          dispatch(
            catchError(ex, (error) => {
              return loadError(error);
            })
          )
        );  
    } else {
      return post("/api/configurator/save", {
        articleNumber,
        quantity: quantity,
        orderRow,
        data: selections,
        selectedUnit,
        deliveryDetails: deliveryDetails,
        selectedRecommendedProducts
      })
        .then((response) => response.json())
        .then((cart) => {
           const recommendedIds = Array.isArray(selectedRecommendedProducts)
            ? selectedRecommendedProducts.map(x => x.articleNumber)
            : [];
          const addedProducts = [articleNumber, ...recommendedIds];
          dispatch(receive({ ...cart, addedProducts }),  dispatch(hideCustomizedMessage()));
        })
        .then(() => {
          if (isUpdateMode == false) {
            document.querySelector("#mini-cart").showPopover();
          }
        });
      // .catch(ex => dispatch(catchError(ex, error => loadError(error))))
    }
  };
};


export const close = () => ({
  type: CONFIGURATOR_CLOSE
});

export const load = (presets, config, articleNumber) => {
  return (dispatch) => {
    if (config.rules.isCoil) {
      let coilMaxWeight = config.selections["maxWeightCoils"] != null ? config.selections["maxWeightCoils"] : "";
      let coilMaxHeight = config.selections["maxHeightCoils"] != null ? config.selections["maxHeightCoils"] : "";
      let cuttingLength = config.selections["cuttingLength"] != null ? config.selections["cuttingLength"] : "";
      dispatch(updateButtonStatus(true));
      if(cuttingLength!="")
      {
        dispatch(updateButtonStatus(false));
      }
      if (coilMaxWeight != "") {
        dispatch(updateButtonStatus(false));
      }
      if (coilMaxHeight != "") {
        dispatch(updateButtonStatus(false));
      }
      
    }
    return dispatch(setPresets(config));
  };
};

export const setValues = (value) => ({
  type: CONFIGURATOR_SET,
  payload: value,
});
export const setTempValues = (value) => ({
  type: CONFIGURATOR_SET_TEMP,
  payload: value,
});
export const updateButtonStatus = (isDisabled) => ({
  type: CONFIGURATOR_SET_SAVEBUTTONDISABLE,
  payload: isDisabled,
});
export const clearSettings = (value) => ({
  type: CONFIGURATOR_CLEAR,
  payload: value,
});
export const setDeliveryDetailsValues = (value) => ({
  type: DELIVERYCONFIG_SET,
  payload: value,
});

export const setPresets = (state) => ({
  type: CONFIGURATOR_LOAD,
  payload: state,
});

export const addRecommendedProduct = (articleNumber, quantity ,selectedUnit) => ({
  type: ADD_RECOMMENDED_PRODUCT,
  payload: { articleNumber, quantity,selectedUnit },
});
export const removeRecommendedProduct = (articleNumber) => ({
  type: REMOVE_RECOMMENDED_PRODUCT,
  payload: articleNumber,
});
export const updateRecommendedProductQuantity = (articleNumber, quantity) => ({
  type: UPDATE_RECOMMENDED_PRODUCT_QUANTITY,
  payload: { articleNumber, quantity },
});
